/**
 * noticeLink — following the in-app address a notice names as its fix (2026-10-18, routines that wait and resume by
 * themselves). Most fixes are a page (`/integrations?…`, `/subscription`); a fix made by talking to Prest0n or by adding
 * someone back is the routine's own thread, `/?thread=<id>&ws=<workspace>` — the address a notification opens a thread
 * by (threadDeepLink.ts). A live navigation to that address never reaches the chat's boot consumer, which reads the
 * address once, so a thread opens the way a bell row opens one; every other address is navigated to. The thread opener
 * loads only when one is followed: the headers that carry this stay as small as they were.
 */

/** The thread a notice's fix address names, only in the waits' own shape (routineWaits.isRoutineWaitFixPath); else null. */
export function noticeLinkThread(path: string): { threadId: string; ws: string | null } | null {
  const m = /^\/\?thread=([A-Za-z0-9_-]{1,128})(?:&ws=([A-Za-z0-9_-]{1,128}))?$/.exec(String(path || ''));
  return m ? { threadId: m[1], ws: m[2] ?? null } : null;
}

/** Follow a notice's fix: its thread opens as a bell row's does; any other address is navigated to. */
export function followNoticeLink(path: string, navigate: (to: string) => void): void {
  const thread = noticeLinkThread(path);
  if (!thread) {
    navigate(path);
    return;
  }
  void import('./threadDeepLink')
    .then(({ openThreadFromNotification }) => openThreadFromNotification(thread))
    .catch(() => navigate(path));
}
